import PropTypes from "prop-types";
import Reveal from "../Reveal/Reveal";
import "./Timeline.scss";

/**
 * Vertical timeline. Each item:
 * { key, period, title, subtitle, meta, body, tags, current }
 */
const Timeline = ({ items, headingLevel = "h3", compact = false }) => {
  const Heading = headingLevel;
  return (
    <ol className={`timeline${compact ? " timeline--compact" : ""}`}>
      {items.map((item, i) => (
        <Reveal as="li" key={item.key} className="timeline__item" delay={i * 0.06}>
          <span
            className={`timeline__dot${item.current ? " is-current" : ""}`}
            aria-hidden="true"
          />
          <div className="timeline__period">
            {item.period}
            {item.current && <span className="timeline__badge">Current</span>}
          </div>
          <div className="timeline__content">
            <Heading className="timeline__title">{item.title}</Heading>
            {item.subtitle && <p className="timeline__subtitle">{item.subtitle}</p>}
            {item.meta && <p className="timeline__meta">{item.meta}</p>}
            {item.body && !compact && <p className="timeline__body">{item.body}</p>}
            {item.tags && item.tags.length > 0 && !compact && (
              <ul className="tag-list timeline__tags" aria-label="Technologies">
                {item.tags.map((t) => (
                  <li key={t} className="tag">
                    {t}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </Reveal>
      ))}
    </ol>
  );
};

Timeline.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  headingLevel: PropTypes.oneOf(["h2", "h3", "h4"]),
  compact: PropTypes.bool,
};

export default Timeline;
